import { isYoutubeAccessible } from './utilities/is-youtube-accessible';
export var JabraVideoDirective = [
    '$q',
    function ($q) {
        return {
            link: function (_$scope, $element) {
                var $scope = _$scope;
                var srcAttribute;
                var videoUrl;
                var html;
                if (!$scope.youtube && !$scope.ku6) {
                    return;
                }
                $q.when(isYoutubeAccessible())
                    .then(function (youtubeAccessible) {
                    if (youtubeAccessible) {
                        // Building Youtube video URL.
                        videoUrl = "//www.youtube.com/embed/" + $scope.youtube + "?rel=0&showinfo=0&iv_load_policy=3";
                        videoUrl += "&controls=" + Number($scope.controls !== 'false');
                        videoUrl += "&autoplay=" + Number($scope.autoplay === 'true');
                    }
                    else {
                        // Building KU6 video URL.
                        videoUrl = "//player.ku6.com/refer/" + $scope.ku6 + "/v.swf&amp;adss=0&amp;&amp;pl=0&amp;pv=0&amp;so=0";
                        videoUrl += "auto=" + Number($scope.autoplay === 'true');
                    }
                })
                    .finally(function () {
                    if (!videoUrl) {
                        return;
                    }
                    srcAttribute = $scope.lazy === 'true' ? 'data-src' : 'src';
                    html = "<iframe class=\"embed-responsive-item\" " + srcAttribute + "=\"" + videoUrl + "\"></iframe>";
                    $element.html(html);
                });
            },
            restrict: 'E',
            scope: {
                autoplay: '@',
                controls: '@',
                ku6: '@',
                lazy: '@',
                youtube: '@',
            },
        };
    },
];
